const instruments = [
    {
      id: 1,
      img: 'https://static.dnipro-m.ua/cache/products/7259/thumb_220946.jpg',
      name: 'Шуруповерт',
      price: 1500,
      description:
        'Мережевий дриль-шуруповерт TD-30 — надійний помічник для робіт по дому та в невеликій майстерні, якщо необхідно виконувати роботу переважно з закручування кріпильних елементів. Муфта регулювання крутного моменту робить інструмент універсальним вибором як для свердління, так і для роботи з кріпленнями.',
    },
    {
      id: 2,
      img: 'https://static.dnipro-m.ua/cache/products/5522/thumb_300448.jpg',
      name: 'Перфоратор',
      price: 3948,
      description:
        'Перфоратор бочковий Dnipro-M ВН-20 використовується для виконання широкого спектру будівельних і ремонтних робіт: буріння та свердління отворів, розмішування будівельних сумішей, демонтажу і т.д.',
    },
    {
      id: 3,
      img: '	https://static.dnipro-m.ua/cache/products/992/thumb_306004.jpg',
      name: 'Шліфмашина',
      price: 1299,
      description:
        'Кутова шліфувальна машина Dnipro-M GS-98 – модель, яка поєднує в собі оптимальне співвідношення потужності, ваги та мобільності. Конструкція шліфмашини сприяє зручній та надійній роботі, навіть однією рукою. Інструмент ідеально підходить для виконання різу на висоті та використання у важкодоступних місцях. Низький рівень шуму та вібрації, двопозиційне розташування додаткової рукоятки під кутом 100 градусів, мінімізує втому під час шліфування.',
    },
    {
      id: 4,
      img: 'https://static.dnipro-m.ua/cache/products/5596/catalog_origin_191105.jpg',
      name: 'Пила',
      price: 11049,
      description:
        'Мобільна акумуляторна ланцюгова пила DCS-200BC DUAL призначена для обрізання зайвих гілок, спилювання дерев та чагарника, заготівлі дров, покрою будматеріалів та демонтажних робіт. Її просто використовувати у будь-яких місцях: на висоті, на виїзних роботах, у лісі або саду. При цьому Вам не потрібно буде турбуватися про підключення до мережі.',
    },
    {
      id: 5,
      img: 'https://static.dnipro-m.ua/cache/products/6387/thumb_299763.jpg',
      name: 'Рівень',
      price: 897,
      description:
        'Рівень серії ProVision виробництва DNIPRO-M має не тільки високу точність вимірювань і чудові захисні властивості, а й надає максимальний комфорт користувачеві в процесі експлуатації.',
    },
    {
      id: 6,
      img: 'https://static.dnipro-m.ua/cache/products/6371/thumb_305028.jpg',
      name: 'Тример',
      price: 3699,
      description:
        'Тример електричний Dnipro-M 110 призначений для покосу густої трави, а також кущів з діаметром стовбура до 10 мм.',
    },
    {
      id: 7,
      img: '	https://static.dnipro-m.ua/cache/products/6483/thumb_308991.jpg',
      name: 'Мотокоса',
      price: 11049,
      description:
        "Мотокоса Dnipro-M 43 призначена для покосу трави, чагарників, бур'янів, газонів, а також для заготівлі сіна в невеликих масштабах.    Використовується для польових робіт на садовій ділянці площею до 2000 м2.",
    },
    {
      id: 8,
      img: 'https://static.dnipro-m.ua/cache/products/2747/thumb_301853.jpg',
      name: 'Генератор',
      price: 10890,
      description:
        'Бензиновий генератор GX-25 номінальною потужністю 2,5 кВт забезпечить автономність побутових приладів на дачі або у приватному будинку. Ви зможете одночасно підключити до нього освітлення, холодильник, зарядку телефону, ноутбук та водяний насос.',
  },
    {
      id: 9,
      img: 'https://static.dnipro-m.ua/cache/products/5631/thumb_307822.jpg',
      name: 'Набір інструментів',
      price: 3999,
      description:
        'Покриття торцевих головок:двошарове нікелеве, (112 шт.)',
  },
    {
      id: 10,
      img: 'https://static.dnipro-m.ua/cache/products/7853/thumb_308861.jpg',
      name: 'Циркулярна пила',
      price: 2397,
      description:
        'Дозволяє здійснювати прямий і косий розпил, змінювати кут руху розпилу під час роботи, контролювати глибину пропила.',
  },
    {
      id: 11,
      img: 'https://static.dnipro-m.ua/cache/products/1333/thumb_309400.jpg',
      name: 'Електрорубанок',
      price: 3759,
      description:
        'За допомогою електрорубанка можна обробляти плоскі поверхні суцільної деревини, а також виготовляти в суцільній деревині пази і фальці.',
  },
    {
      id: 12,
      img: 'https://static.dnipro-m.ua/cache/products/5380/thumb_188806.jpg',
      name: 'Штроборіз',
      price: 8997,
      description:
        'Будівельний електроінструмент, призначенням якого є створення на поверхні стін, підлоги або стелі канавок технічного призначення.',
  },   
  ];


export {instruments}